import { buildPointSettingPayload, getPointBoosterSyncOrder, PointSettingFormValue } from './points-setting-utils'

interface PointSettingStatuses {
    point_get_config?: { status?: number }
    point_deduction_config?: { status?: number }
}

type SaveConfig = (url: string, params: any) => Promise<any>

export const savePointSettings = async (
    values: PointSettingFormValue,
    current: PointSettingStatuses | undefined,
    saveConfig: SaveConfig,
) => {
    const payload = buildPointSettingPayload(values)
    await saveConfig('/activity/updatepointsrules', {
        redemption_ratio: payload.redemption_ratio,
        mall_redemption_ratio: payload.mall_redemption_ratio,
        rules_list: payload.rules_list,
        redemption_range_list: payload.redemption_range_list,
        expiration: payload.expiration,
        expiration_deal: payload.expiration_deal,
    })
    if (values.point_enable && current?.point_get_config?.status !== 0) {
        await saveConfig('/activity/enablememberpoints', {})
    }

    if (values.deduction_enable) {
        await saveConfig('/activity/updatepointdeduction', {
            frequency: payload.deduction_frequency,
            status: 0,
            money: payload.money,
            high_precision_money: payload.high_precision_money,
            percentage_ceiling: payload.percentage_ceiling,
            mall_percentage_ceiling: payload.mall_percentage_ceiling,
            base_amount: payload.base_amount,
            is_default_used: payload.is_default_used,
            weekdays: payload.deduction_weekdays,
            monthdays: payload.deduction_monthdays,
        })
        if (current?.point_deduction_config?.status !== 0) {
            await saveConfig('/activity/enablepointdeduction', {})
        }
    } else if (current?.point_deduction_config?.status === 0) {
        await saveConfig('/activity/disablepointdeduction', {})
    }

    for (const level of getPointBoosterSyncOrder(values.levels || [])) {
        await saveConfig('/activity/updatepointbooster', {
            level_booster: {
                member_level_id: level.member_level_id ?? null,
                level: level.level ?? null,
                multiplier: level.multiplier == null ? null : Number(level.multiplier),
            },
        })
    }

    if (!values.point_enable && current?.point_get_config?.status === 0) {
        await saveConfig('/activity/disablememberpoints', {})
    }
}
